import type { MouseRtConfigSnapshot, RtSide } from '@rapoo/device-sdk'

export type RtSelectionMode = 'both' | RtSide

/** 校准页中单个按键的视觉状态。 */
export type CalibrationVisualState = 'idle' | 'triggered' | 'passed'

/** 一项 RT 配置在鼠标左右键上的值。 */
export type RtPresetSideValue<T> = Readonly<Record<RtSide, T>>

/** RT 预设包含的完整按键触发配置。 */
export interface RtPresetConfig {
  readonly index: number
  /** 官方预设使用 i18n key，用户预设使用 name。 */
  readonly nameKey?: string
  readonly name?: string
  readonly source?: 'official' | 'user'
  readonly cloudId?: string
  readonly settings: MouseRtConfigSnapshot
}

/** 四类 RT 配置共用的标题与图标，供 Tab、概览和预设详情统一使用。 */
export const RT_CONFIG_SECTION_META = {
  travel: {
    titleKey: 'rt.sections.triggerTravel',
    icon: 'Technology-Fill-Rapid',
  },
  rapidTrigger: {
    titleKey: 'rt.sections.rapidTrigger',
    icon: 'Technology-Wireframe-Sensitive',
  },
  vibration: {
    titleKey: 'rt.sections.vibration',
    icon: 'Technology-Wireframe-AbsPriorityTrigger',
  },
  sound: {
    titleKey: 'rt.sections.sound',
    icon: 'Technology-Fill-Music',
  },
} as const

/**
 * 数值型 RT 字段的 key — 全部走 setField。
 * - 触发级别 → RtTravelCard（单字段卡片）
 * - RT 级别 → RtSensitivityCard（与开关配对，开关关闭时隐藏）
 * - 振动按下 / 振动释放 → RtVibrationCard（共享模式选择器）
 * - Beep 按下 / Beep 释放 / Beep 音量 → RtBeepCard（共享模式选择器）
 *
 * RT 开关单独用 toggle 控件，与之并不同形。
 */
export type RtFieldKey =
  | 'triggerPress'
  | 'rtLevel'
  | 'vibrationPress'
  | 'vibrationRelease'
  | 'beepPress'
  | 'beepRelease'
  | 'beepVolume'

export interface RtSliderConfig {
  field: RtFieldKey
  title: string
  min: number
  max: number
  step: number
  unit: string
}

export const RT_BUTTONS: RtSide[] = ['left', 'right']
